import {
	Alert,
	Box,
	Dialog,
	DialogActions,
	DialogContent,
	Divider,
	Typography,
} from "@mui/material";
import { DetailHeader } from "@/controls/detail-panel/DetailPanel";
import { FooterModalButtons } from "@/controls/buttons/FooterModalButtons";

interface Props {
	open: boolean;
	title: string;
	message: string;
	confirmLabel: string;
	confirmColor?: "primary" | "warning" | "error";
	isSaving?: boolean;
	error?: string;
	onConfirm: () => void;
	onClose: () => void;
}

export const ConfirmActionDialog = ({
	open,
	title,
	message,
	confirmLabel,
	confirmColor = "primary",
	isSaving = false,
	error,
	onConfirm,
	onClose,
}: Props) => (
	<Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
		<DetailHeader title={title} isSaving={isSaving} onClose={onClose} />
		<form
			onSubmit={(e) => {
				e.preventDefault();
				onConfirm();
			}}
		>
			<DialogContent sx={{ py: 2, px: "27px" }}>
				<Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
					<Typography>{message}</Typography>
					{error && <Alert severity="error">{error}</Alert>}
				</Box>
			</DialogContent>
			<Divider />
			<DialogActions sx={{ px: 2, py: 1.5 }}>
				<FooterModalButtons
					isSubmitLoading={isSaving}
					onHide={onClose}
					buttonColor={confirmColor}
					buttonLabel={confirmLabel}
				/>
			</DialogActions>
		</form>
	</Dialog>
);
